export default {
  lineColor: 'L',
  lineColorFull: 'Couleur de la ligne',
  fillColor: 'F',
  fillColorFull: 'Couleur de Remplissage',
  alpha: 'A',
  alphaFull: 'Alpha',
  lineWidth: 'W',
  lineWidthFull: 'Largeur de ligne',
  eraserWidth: 'E',
  eraserWidthFull: 'Largeur de la gomme',
  textColor: 'C',
  textColorFull: 'Couleur du texte',
  fontSize: 'S',
  fontSizeFull: 'Taille de Police',
  fontStrokeSize: 'St',
  fontStrokeSizeFull: 'Largeur du trait',
  fontStyle: 'FS',
  fontStyleFull: 'Style de police',
  fontName: 'F',
  fontNameFull: 'Nom de la police',
  textStrokeColor: 'SC',
  textStrokeColorFull: 'Couleur de course',
  apply: 'Appliquer',
  cancel: 'Annuler',
  close: 'Fermer',
  clear: 'Effacer',
  width: 'Largeur',
  height: 'Hauteur',
  keepRatio: 'Conserver le rapport largeur/hauteur',
  fillPageWith: 'Remplir avec la couleur d\'arrière-plan en cours',
  pixelSize: 'P',
  pixelSizeFull: 'Taille de Pixel',
  resizeScale: 'Échelle',
  resizeResize: 'Redimensionner',
  backgroundColor: 'Couleur de fond de la page',
  pixelizePixelSize: 'Pixéliser la taille de pixel',
  language: 'Langue',
  wrongPixelSizeValue:
    'Maubaise taille de pixel. Vous pouvez ajouter par exemple e.g. \'20%\' ce qui signifie que la taille moyenne des pixels sera 1/5 de la ' +
    'surface sélectionnée, ou \'4\' signifie 4 px',
  tools: {
    crop: 'Recadrer l\'image dans la zone sélectionnée',
    pixelize: 'Pixélise la zone sélectionnée',
    rect: 'Dessiner un rectangle',
    ellipse: 'Dessiner une ellipse',
    line: 'Dessiner une ligne',
    rotate: 'Pivoter l\'image',
    save: 'Enregistrer l\'image',
    load: 'Charger l\'image',
    text: 'Mettre du texte',
    brush: 'Brosse',
    resize: 'Redimensionner ou échelle',
    open: 'Ouvrir l\'image',
    select: 'Sélectionnez une région',
    close: 'Fermer Painterro',
    eraser: 'Gomme',
    settings: 'Réglages',
  },
  pasteOptions: {
    fit: 'Remplace tout',
    extend_down: 'Étendre vers le bas',
    extend_right: 'Étendre à driot',
    over: 'Coller sur',
    how_to_paste: 'Comment coller?',
  },
};
